function foreignIDValidator({ input, msgs }) {
  const rule = /^[a-zA-Z0-9 \\-]+$/;

  if (!rule.test(input)) {
    return (msgs && msgs.msg) || 'Special characters are not allowed in this field.';
  }

  return null;
}

export default foreignIDValidator;
